module.exports = __webpack_public_path__ + "static/media/whatsapp5.bc17bf11.png";